import axios from "axios";
import {ClientNoteType} from "./notes.types";

/**
 * Get all client's notes
 *
 * @param uuid
 * @param clientUuid
 */

async function getClientNotesApi(uuid: string, clientUuid: string) {
    return axios({
        method: 'GET',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/notes`,
    });
}

/**
 * Create new client's note
 *
 * @param uuid
 * @param clientUuid
 * @param data
 */
async function postClientNoteApi(uuid: string, clientUuid:string, data: any) {
    return axios({
        method: 'POST',
        url: `/api/v1/workspaces/${uuid}/clients/${clientUuid}/notes`,
        data:data
    });
}

/**
 *  Get single client's note
 *
 * @param uuid
 * @param clientUuid
 * @param noteUuid
 */

async function getClientNoteApi(uuid:string, clientUuid:string, noteUuid:string){
    return axios({
        method:"GET",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/notes/${noteUuid}`
    })
}

/**
 * Update client's note
 *
 * @param uuid
 * @param clientUuid
 * @param noteUuid
 * @param data
 */

async function patchClientNoteApi(uuid:string, clientUuid:string, noteUuid:string, data:ClientNoteType){
    return axios({
        method:"PATCH",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/notes/${noteUuid}`,
        data:data
    })
}

/**
 * Delete client's note
 *
 * @param uuid
 * @param clientUuid
 * @param noteUuid
 */

async function deleteClientNoteApi(uuid:string, clientUuid:string, noteUuid:string){
    return axios({
        method:"DELETE",
        url:`/api/v1/workspaces/${uuid}/clients/${clientUuid}/notes/${noteUuid}`
    })
}

export {
    getClientNotesApi,
    postClientNoteApi,
    getClientNoteApi,
    patchClientNoteApi,
    deleteClientNoteApi
}
